const isLocal = window.location.hostname === "localhost";

export const MAILSERVER_BASE = isLocal
  ? "https://modularobjects.com/mailserver/api"
  : "/mailserver/api";